import http from '@http';
import apis from './apis';

const axios = http();

export default class SystemService {
    static getWechatConfig(url) {
        return axios.get(apis.wechatConfig, {
            params: {
                url,
            },
        });
    }

    static thirdLogin(params) {
        return axios.post(apis.thirdLogin, params);
    }

    static getInfo() {
        return axios.post(apis.getInfo, {});
    }

    static wechath5login(params) {
        return axios.post(apis.wechath5login, params);
    }

    static getUploadTokenUrl(params) {
        return axios.get(apis.getUploadTokenUrl, {
            params,
        });
    }
}
